export class ActionResult {
    public Status: string;
    public Message: string;
    public Item: any;
}


// WEBPACK FOOTER //
// ./src/entities/actionResult.ts